import { ApaduaLegacyAPI } from 'src/apis/ApaduaLegacyAPI';

export class ClientQuestionsLegacyAPI extends ApaduaLegacyAPI {
    resource: string = 'api/client-questions/';

    create(payload): Promise<Array<any>> {
        const requestPayload = {
            data: {
                attributes: {
                    question: payload.question,
                    'user-company': payload.company,
                    'user-email': payload.email,
                    'user-full-name': payload.fullName,
                    'user-phone': payload.phoneNumber,
                },
                relationships: {
                    proposal: {
                        data: {
                            type: 'proposals',
                            id: payload.proposalID,
                        },
                    },
                },
                type: 'client-questions',
            },
        };

        return this.post('', requestPayload) as any;
    }
}
